import React, { useEffect } from 'react';
import './style.scss';
import {
  GetNotificationInfoQueryVariables,
  ReadNotificationParam,
  useReadNotificationMutation,
} from 'views/utils/graphql/graphql';
import { useGetNoticeDetail } from './hooks/useGetNoticeDetail';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { checkNoticeLabel } from '../notice/function/createBodyShowList';
import { formatDate } from 'views/utils/format/FormatDate';
import useOnceSubmit from 'views/utils/useOnceSubmit';
import { useGlobalToastHandler } from 'views/components/organisms/globalToast/hooks';
import { useGlobalLoadingHandler } from 'views/components/organisms/globalLoading/hook';

type NoticeDetailProps = {
  noticeId: string;
  setIsOpenModal: (isOpenModal: boolean) => void;
  resetNoticeList: () => void;
};

export const NoticeDetail = (props: NoticeDetailProps) => {
  const getNewNoticeDetailVariables = () => {
    const param: GetNotificationInfoQueryVariables = {
      id: props.noticeId,
    };
    return param;
  };
  const { noticeDetail, getNoticeDetail, setNoticeDetailVariables } = useGetNoticeDetail(getNewNoticeDetailVariables());

  const [readNoticeData, readNotice] = useReadNotificationMutation();
  const { showError } = useGlobalToastHandler();

  const { showLoading, hideLoading, setLoadingCenter } = useGlobalLoadingHandler();

  useEffect(() => {
    setLoadingCenter(true);
    if (noticeDetail.fetching) {
      showLoading();
    } else {
      hideLoading();
    }
  }, [noticeDetail]);

  const onSubmit = useOnceSubmit<void>(
    {
      onPreviousSubmit: async () => {
        const notice = noticeDetail?.data?.GetNotificationInfo;
        if (notice?.DeliveryTarget === 1) {
          props.setIsOpenModal(false);
        }
        if (notice?.Confirmed) {
          props.setIsOpenModal(false);
        }
        if (notice?.Confirmed) return false;
        if (notice?.DeliveryTarget === 1) return false;

        return true;
      },
      onSubmit: async () => {
        const param: ReadNotificationParam = {
          ID: props.noticeId,
        };
        const readNoticeData = await readNotice({
          input: param,
        });
        if (readNoticeData?.data?.ReadNotification?.Code === 0) {
          props.resetNoticeList();
          props.setIsOpenModal(false);
        } else if (readNoticeData?.data) {
          showError(readNoticeData.data.ReadNotification?.Message);
        }
      },
      isLoadingForceCenter: true,
    },
    [props.noticeId, props.setIsOpenModal, props.resetNoticeList, noticeDetail, readNotice, showError],
  );

  const notice = noticeDetail.data?.GetNotificationInfo;

  const urlRegex = /https?:\/\/[^\s<>"']+/g;
  const linkedContents =
    notice?.Contents.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    }) ?? '';

  return (
    <div className="noticeDetailWrapper">
      {/* お知らせタイトル */}
      <div className="detailHeader">
        {notice?.DeliveryType && <div className="detailHeader_label">{checkNoticeLabel(notice?.DeliveryType)}</div>}
        <div className="detailHeader_name">{notice?.Title}</div>
        {notice?.DeliveryTarget === 2 && (
          <div className="detailHeader_amount">{notice?.Confirmed ? '確認済' : '未確認'}</div>
        )}
        <div className="detailHeader_date">{notice?.PublishStartDate}</div>
      </div>

      <div className="DetailBody">
        {/* お知らせ本文 */}
        <div className="DetailBody_content" dangerouslySetInnerHTML={{ __html: linkedContents }}></div>
        {/* お知らせ確認日時 */}
        {notice?.ConfirmDateTime && notice?.DeliveryTarget === 2 && (
          <div className="DetailBody_confirm">{'確認日 : ' + formatDate(notice?.ConfirmDateTime)}</div>
        )}
      </div>

      <Button
        label={notice?.DeliveryTarget === 2 ? (notice?.Confirmed ? '閉じる' : '確認する') : '閉じる'}
        fillType={FillType.primaryFill}
        buttonSize={ButtonSize.sizeM}
        onClick={onSubmit}
      />
    </div>
  );
};
